import { render, staticRenderFns } from "./VAdminCategoryCard.vue?vue&type=template&id=cc05dcf0"
import script from "./VAdminCategoryCard.vue?vue&type=script&lang=js"
export * from "./VAdminCategoryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports